import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from "@angular/common";
import { RouterLink } from "@angular/router";


@Component({
  selector: 'app-footer',
  standalone: true,
    imports: [
        RouterLink
    ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit, AfterViewInit{
    year: number;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.year = new Date().getFullYear();
    }

    ngOnInit() {}

    ngAfterViewInit() {
        if (isPlatformBrowser(this.platformId)) {
            const btn = document.getElementById('backToTop');
            window.onscroll = () => {
                if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                    btn!.style.display = 'block';
                } else {
                    btn!.style.display = 'none';
                }
            };
            btn!.onclick = () => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            };
        }
    }
}
